<template>
  <div v-if="page">
    <page-banner
      :title="page.banner.title"
      :text="page.banner.text"
      :colour="page.banner.colour"
    />
    <div class="grid-x align-center">
      <div class="cell small-11 medium-10">
        <news-items :home-slug="homeSlug" :colour="page.banner.colour"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import PageBanner from '@/components/PageBanner.vue';
  import NewsItems from '@/components/NewsItems.vue';

  export default {
    metaInfo() {
      return {
        title: 'Weekly Updates'
      }
    },
    components: {
      PageBanner,
      NewsItems,
    },
    props: {
      homeSlug: String
    },
    mounted() {
      this.fetchPage('weekly-updates')
        .then(() => {
        });
    },
    methods: {
      ...mapActions([
        'fetchPage'
      ])
    },
    computed: {
      page() {
        return this.$store.getters.getPage('weekly-updates');
      }
    }
  }
</script>
